const configBsc = {
  mafiaAddress: "0x3cb3F4f43D4Be61AA92BB4EEFfe7142A13bf4111",
  pairAddress: "0xdE6e6378623C4F2c1102F2CcD35507d5bAf7924d",
  vaultAddress: "0xB88Aa2B2345eb37ab21Ed9359AF1c937ca6D07aF",
  vault1Address: "0xCABDd520EeDC6736F4C057Cba275673d74766A6b",
  profileAddress: "0xa08D627E071cB4b53C6D0611d77dbCB659902AA4",
  profileUnboxAddress: "0x62523f9e93432ad4DB2903233B3463Ba64D4D911",
  ftsAddress: "0x4d0913F632CFd36750ff2045eA473CDA5a1889F1",
  ftsMarketAddress: "0x165Db3Cab10541a274658f0b5928ee96b8A7F738",
  ftsSubscriptionAddress: "0x8ee3bB9a95Cf253FA5391CAc8bFd8e435875384e",
  ftsInitialSupply: 3_286,

  mafiaFamilyAddress: "0x1bC581fe134BdC7432eF8ba75BCeEd242F90BcD2",
  familyBankAddress: "0xA7AB556Aac595A8425dDF584f3CA11bbD1772B8b",
  /** MafiaFamilyCashBank — in-game cash family bank (deposit / withdraw) */
  familyCashBankAddress: "0x26cDB03a72Ac5866d43184526F4586D8942739F2",
  ogCrateAddress: "0x16B11C057cA6d354E81D58B375CB118f7930807c",
  crateMinterAddress: "0x1F4Eb51E87C4e2368316dba8e478Cd561FEb8B77",
  inventoryAddress: "0x2CB8352Be090846d4878Faa92825188D7bf50654",
  marketAddress: "0x1fb8C9F810afd99A6FAE3E81aBe0806f8796ba73",
  ogNFTAddress: "0xaf46bd44259b89f01B861C056C813228ADdfaD22",
  ogPremiumAddress: "0xA7AcE7F549BDE0b915EB06A6dAb3C9292cCa8B45",

  gamebankAddress: "0x376554F7BbcdeB348fa4b8371135B87eC6b29c38",
  exchangeAddress: "0x605694A29c5258D6c7Aed642D01111c4b7036966",
  depositAddress: "0xB081EC0763360a9Ad4D09AF2C9ec7DC1ED5190Ae",
  vaultSplitterAddress: "0x46f3F348a21BFEE36E1EacA57E91C08c733b73eD",

  mapAddress: "0x1c88060e4509c59b4064A7a9818f64AeC41ef19E",

  daoAddress: "0xD772D9f127b15d81c46582D49426d319044a541d",

  proposalAddress: "0x727405987580B9C44052f8F1f82Fa268C966Ba09",
  rouletteAddress: "0x53e579dC9BE49B6Bac08c6F9ffA83D981A9A19F3",
  slotAddress: "0xa593553bdbA38730226aaabF07D241a16a3fc005",
  rankXpAddress: "0x48F2C9C0ea337854492aF5bEbEa74e8917712B71",
  jailAddress: "0x7371580cd13dE739C734AE85062F75194d13Fac2",
  basicCrimeAddress: "0x167ad284C7bcc4d6342991Aa258422E7a04f926E",
  smuggleMarketAddress: "0x36b09f1854CF3614Eb8d10fFae847511BB08868e",
  carNickAddress: "0x60B8e0dd9566b42F9CAa5538350aA0D29988373c",

  killSkillAddress: "0xa5dc2Cb4dC13f12d8464eaA862fAC00F19ADc84d",
  killInitiationContractEnabled: false,
  killInitiatorAddress: "0x28411d750C5a3639fF3E5B78C218f617e3bc5484",
  mafiaRebirthAddress: "0x5D20a828693058C5370C6dCb54297f41eC3e2868",
  killRegistryAddress: "0x92a74ea875954134b9cdCa21C7BBD21091e1b6f8",

  helperCreditAddress: "0x192F029CC7e0BB80dB201191E0040e8F801df34d",
  helperBotAddress: "0xE2E4506c23C26eea2526d0e4dBb8dbF9cDa9d105",

  bulletTokenAddress: "0xe92F5d948d8764904F9703ae878a3A9e6b3952eb",
  inGameBulletAddress: "0xa42AE5D3E84bff9cD2C734A072232D9629f2ED16",
  healthAddress: "0xC63668378B83f3E58A9AAAe6E12Da3282F150225",
  bulletFactoryAddress: "0xAbfdA460fFEa2697A4d0b17e955bc17e87b6d45E",
  hospitalAddress: "0xB4c9ef457e17992f9271B447de3507016fd0E0d7",

  bustOutAddress: "0xd401B2af85Df998faaDD0963F0e15e2EB92D5697",
  xpMarketAddress: "0x49F23822AFa248D4bE453d630F7e0dF8fcF80854",

  raceXp: "0x05BE7743913dECe53D93E22120279f0630014743",
  raceLobby: "0xE3a3892fEC9bA9457fEE08Fe3d2E7b32bCeb33Ad",

  perkBoxMinter: "0x55849c0F5A567A49d219B00642A4648389ada6f6",
  perkBoxClaim: "0x474b037904C6af5315ae37a963d8C550D97875D5",
  perkOpener: "0x26563e46A96a07e66BC01Ad6b1b41B42a33364F8",
  perkManager: "0x465001359458Df7812C0c0b7d186aA2843DBf9F7",

  jackpot: "0x2FAcF1371d3e67B98A27490321655ac059f675B2",
  lotteryHall: "0x9BD51e3Ff9FED76db11F718e9E3DcfcB7597e374",
  shop: "0xd922255cCeb4f97e2830038E4e7EF54Cb62B6733",
  training: "0xb7D6c0B1a176711C98cceF191Eb5528F2e703fd5",
  equipment: "0xa2AA522B4CCBc95Dec0aFCa2B0c645f9C126cD24",

  swapRouter: "0xe7cb02aDa01A2100C83De3ab73d93ed18fbd9636",
  giCredit: "0x21b6833B76A4AD783fe681c04Fc9F3A3a0A5b0B7",
  playerSubscription: "0x3CEef7Fe3CcF730b87D0bFC651c680a7a76dCa61",
  giManager: "0xe2f0DaCf0A32B77c1d4F07C8642E90b260E66A91",

  weeklyMission: "0xc82d2eD039af6f01b4A44a11699a73EEB90cBAbB",
  storyMode: "0x4D9d610092B233a24193CB686De1A8746C5224f8",

  familyStakeShare: "0xbb4E73e1809a9cB0B1a6ACC885eac10ba85a7310",
  rankStake: "0xDFfCf5D284D2bA80376BAba90F37494D60fe8820",

  ocLobbyAddress: "0x281C0Db67c96ee7Ad32AF25817cB3964Fc7E79cD",
  ocJoinAddress: "0x00D0933595F87eD8b50638796FCf5b22de3795a2",
  ocExecutionAddress: "0xC813f8EA6668eAb88e157d00F00aeBCb2b5F56C0",

  detectiveAgency: "0x0cCA060E6c22A67eF17E657342548A467D96B3CD",
  carCrusherAddress: "0xC17B536db3431040f1F2A8980B2Eb80B814dD022",
  safehouseAddress: "0x6c7e8317698986c0B92FdDB7CA3086234B5e5F60",

  chainSymbolFull: "BNB",
  chainSymbol: "BNB",
  chainName: "Binance Smart Chain",
  chainId: 56,
  chainIdHex: 0x38,
  blockTime: 3000,
  /** EIP-7825 / BEP-652 per-transaction gas cap */
  maxTxGas: 16_777_216,

  providerList: [
    "https://bsc-dataseed2.bnbchain.org",
    "https://bsc-dataseed2.defibit.io",
    "https://bsc-dataseed4.ninicoin.io",
  ],

  explorerUrl: "https://bscscan.com/",
  nativePriceUrl:
    "https://api.coingecko.com/api/v3/simple/price?ids=binancecoin&vs_currencies=usd",
  mafiaPriceUrl: "https://api.dexscreener.com/latest/dex/pairs/bsc/",
  tradeUrl: "https://pancakeswap.finance/swap",

  domain: "bnb.playmafia.io",
  mapDomain: "https://bnb.playmafia.io/map-game",
  title: "BnbMafia",
  gitbookUrl: "http://bnbmafia.gitbook.io/",

  serverEndpoint: "https://backendbnb.playmafia.io",
  mockServerEndpoint: "http://localhost:5000",
  testServerEndpoint: "https://0w0vnklj-3000.use.devtunnels.ms",

  newFirebaseConfig: {
    apiKey: "AIzaSyArUN3H-Toru5EBdJGano9yrg5YvjOcY3Q",
    authDomain: "bnbmafia-4d1b3.firebaseapp.com",
    projectId: "bnbmafia-4d1b3",
    storageBucket: "bnbmafia-4d1b3.appspot.com",
    messagingSenderId: "4235046852",
    appId: "1:4235046852:web:bbbd2bb1b51fc82e4dbe91",
    measurementId: "G-34J5STVC8V",
  },

  storageBucket: "gs://bnbmafia-4d1b3.appspot.com",

  symbol: "$MAFIA",
  gtagId: "G-K2G5M6ZBQN",
};

export default configBsc;
